import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { UmbracoHttpClient } from "@e-forsyning/common/http";

import { MaalerAflaesningIndstillinger } from "../model/maaler-aflaesning-indstillinger.model";

@Injectable({ providedIn: "root" })
export class FeatureMaalerAflaesningRepository {
    constructor(private readonly umbracoHttp: UmbracoHttpClient) {}

    public hentIndstillinger(): Observable<MaalerAflaesningIndstillinger> {
        return this.umbracoHttp.hentSideData("indtast-aflaesninger").pipe(
            map((result) => ({
                sideTitel: result.menuTekst
            }))
        );
    }
}
